<template>
    <v-container>
    <v-responsive max-width="700" class="mx-auto text-center">
        <!--<div class="text-h3 mb-3">{{$t('plan.title')}}</div>-->
        <!--<h2 class="text-overline text-lg-h2">{{$t('plan.subtitle')}}</h2>-->
        <h2 class="text-h4">{{$t('plan.subtitle')}}</h2>
         <!--
         <v-alert type="warning" colored-border border="left" class="mt-4" v-if="isDowngraded">
          The plan was downgraded to <b>{{ item.paymentInformation.activePlan }}</b> visitors/month. The change will take effect when the next subscription period starts ({{
            formatDate(nextSubscriptionStart, true) }}).
        </v-alert>
        -->
        <div class="text-h6 text-lg-h5 mt-4">{{$t('plan.text')}}</div>
        <v-slider 
        v-if="plan"
        class="mx-10 mt-12"
        color="primary"
        v-model="planIndex"
        thumb-label="always"
        :thumb-size="70"
        :min="0"
        :max="plans.length - 1"
        ticks
      >
      <template v-slot:thumb-label="{ value }">
            <span class="text-subtitle-1">{{ plans[value].visits || $t('plan.more') }}</span>
      </template>
      </v-slider>
      </v-responsive>

      <v-row class="my-2" justify="center" align="center" dense>
        <!--
        <v-col cols="12" lg="2"></v-col>
        -->
        <v-col
          cols="12"
          md="8"
          lg="5"
          xl="4"
          
        >
          <v-card
            v-if="plan"
            class="text-body-1"
            outlined
            light
            elevation="2"
          >
            <v-sheet class="pa-4 text-center">
              <div class="text-h6 font-weight-bold text-uppercase mb-4">DreamROI Standard</div>
              <div v-if="!isLastPlan" class="d-flex justify-center ml-n3">
                <div :class="['font-weight-regular', 'text-h4',  isCurrencyPrefix(plan.currency) ? 'mr-1' : 'ml-1']" style="margin-top: 10px">{{ formatCurrency(plan.currency, true) }}</div>
                <div :class="['text-h2', 'font-weight-black', 'text-number', isCurrencyPrefix(plan.currency) ? 'order-last' : 'order-first' ]">{{ plan.price }}</div>
              </div>
              <div v-else class="d-flex justify-center ml-n3">
                <div :class="['text-h2', 'font-weight-black', 'text-number']">{{ $t('plan.contact') }}</div>
              </div>
              <div v-if="!isLastPlan" class="grey--text justify-end overline">{{$t('plan.perMonth')}}</div>
              <div v-else class="grey--text justify-end overline"><a href="mailto:support@dreamroi.com" style="text-decoration:none">support@dreamroi.com</a></div>
            </v-sheet>
            <v-divider></v-divider>
            <v-sheet class="pa-4" color="grey lighten-5">
              <v-btn
                v-if="!!plan.visits"
                x-large
                block
                outlined
                @click="subscribe(plan.visits, isCurrent(plan))"
                :dark="!isCurrent(plan)"
                :class="[!isCurrent(plan) && 'primary']"
              >{{ isCurrent(plan) ? $t('plan.active') : $t('plan.subscribe') }}</v-btn>
              <v-btn
                v-else
                x-large
                block
                outlined
                href="mailto:support@dreamroi.com"
                target="_blank"
                :dark="!isCurrent(plan)"
                :class="[!isCurrent(plan) && 'primary']"
              >{{ isCurrent(plan) ? $t('plan.active') : $t('plan.quote') }}</v-btn>
              <div class="mb-0 mt-4">
                <div v-for="(feat, j) in features" :key="j" class="d-flex align-center mb-1">
                  <v-icon color="success" class="mr-2">$ok</v-icon>
                  <span v-if="feat.prefix" class="font-weight-regular mr-1">{{ feat.prefix}}</span>
                  <span v-if="feat.value" class="font-weight-black">{{ feat.value }}</span>
                  <span v-if="feat.suffix" class="font-weight-regular ml-1">{{ feat.suffix }}</span>
                </div>
              </div>
              
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
      <v-overlay absolute :value="loading">
      <v-progress-circular class="mx-auto"
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <confirm-dialog v-model="confirmChange" @confirm="changePlan" title="plan.changePlan.warning.title" buttonCaption="dialog.agree" buttonColor="success" buttonIcon="$ok" :buttonText="false">
      <div v-html="warningText"></div>
    </confirm-dialog>
    </v-container>
</template>
<script>
  import { mapState, mapGetters } from "vuex";
  import {mixin as VueTimers} from 'vue-timers'
  import Formatters from "@/mixins/formatters";
  import ConfirmDialog from "@/components/ConfirmDialog"

  export default {
    name: 'Plan',
    mixins:[VueTimers, Formatters],
    components:{ConfirmDialog},
    data() {
      
      return {
        //features: commonFeatures,
        loading: true,
        plans: null,
        paymentInformation: null,
        planIndex: null,
        confirmChange: false,
        newPlan: null,
        warningText: '',
        /*
        plans: [
              { title: 'Starter', price: 100, visits: 10000, features: [{ value: 10000, label: 'visitors'}, ...commonFeatures  ] },
              { title: 'Basic', price: 200, visits: 25000, features: [{ value: 25000, label: 'visitors'},  ...commonFeatures ] },
              { title: 'Standard', price: 500, visits: 75000, features: [{ value: 75000, label: 'visitors'},  ...commonFeatures ] },
              { title: 'Enterprise', price: 1000, visits: 200000, features: [{ value: 200000, label: 'visitors'},  ...commonFeatures ] },
              { title: 'Custom', price: 'Request quote', features: [{ value: '>50000', label: 'Unique monthly visitors'}, ]  }
              
        ]
        */
      };
    },
    computed: {
        features() {
          return [
            { prefix: this.$t('plan.features.recommender.value'), value: this.$t('plan.features.recommender.label') },
            { value: this.$t('plan.features.webboxes.value'), suffix: this.$t('plan.features.webboxes.label') },
            { value: this.$t('plan.fetures.personalization.value'), suffix: this.$t('plan.features.personalization.label') },
            { value: this.$t('plan.fetures.prediction.value'), suffix: this.$t('plan.features.prediction.label') },
            { value: this.$t('plan.fetures.automation.value'), suffix: this.$t('plan.features.automation.label') },
            { value: this.$t('plan.fetures.contacts.value') },
            { prefix: this.$t('plan.features.retargeting.value'), value: this.$t('plan.features.retargeting.label') },
            { value: this.$t('plan.features.btc.value'), suffix: this.$t('plan.features.btc.label') },
            { value: this.$t('plan.features.scheduled.value'), suffix: this.$t('plan.features.scheduled.label') },
            { value: this.$t('plan.features.automatic.value'), suffix: this.$t('plan.features.automatic.label') },
            { prefix: this.$t('plan.features.analytics.value'), value: this.$t('plan.features.analytics.label') },
            //{ value: this.$t('plan.features.editor.value'), label: this.$t('plan.features.editor.label') },
            //{ value: this.$t('plan.features.emails.value'), label: this.$t('plan.features.emails.label') },
            
            //{ value: this.$t('plan.features.collaborators.value'), label: this.$t('plan.features.collaborators.label') },
          ];
        },
        current() {
            return this.plans.find(p => this.isCurrent(p)) || 0;
        },
        plan() {
          return this.plans?.[this.planIndex];
        },
        isLastPlan() {
          return this.plans?.length == this.planIndex + 1;
        },
        nextSubscriptionStart() {
          let d = new Date(this.item.activeSubscription.to);
          d.setDate(d.getDate() + 1);
          return d;
        },
        ...mapState('companies', ['item']),
        ...mapGetters('companies', ['isDowngraded'])
    },
    methods: {
        isCurrent(p) {
            return this.item?.hasStripeSubscription && ((p.visits == this.item?.activeSubscription?.monthlyUserLimit) || (!p.visits && this.item?.activeSubscription?.monthlyUserLimit > this.plans[this.plans.length - 2]));
        },
        async subscribe(visitors, current) {
          if(current) {
            return;
          }
          if(this.isDowngraded && visitors > this.paymentInformation?.activePlan) {
            this.$store.dispatch('ui/notify', {text: this.$t('plan.errors.downgradeMultiple'), error: true});
            return;
          }

          console.debug('downgrade check', this.item.stats?.monthlyUsers, visitors, this.paymentInformation?.activePlan, this.item.stats?.monthlyUsers > visitors,  visitors < this.item.paymentInfo?.activePlan);
          if(this.item.stats?.monthlyUsers > visitors && visitors < this.paymentInformation?.activePlan) {
            this.$store.dispatch('ui/notify', {text: this.$t('plan.errors.downgradeQuota'), error: true});
            return;
          }
          
          if(this.item.hasStripeSubscription) {
            // show dialog, save new plan
            var priceDiff = this.current.price - this.plan.price;
            if(!isNaN(priceDiff)) {
              
              if(priceDiff < 0) {
                // upgrade
                priceDiff *= -1;
                this.warningText = this.$t('plan.changePlan.warning.upgrade', { price: this.formatCurrencyAmount(priceDiff, this.plan.currency)});
              } else {
                // downgrade
                this.warningText = this.$t('plan.changePlan.warning.downgrade', { price: this.formatCurrencyAmount(priceDiff, this.plan.currency)});
              }
            } else {
              this.warningText = this.$t('plan.changePlan.warning.text');
            }
            this.confirmChange = true;
            
            this.newPlan = visitors;
            return;
          } else {
            this.loading = true;  
            let checkoutUrl = await this.$store.dispatch('companies/createSubscription', { companyID: this.item.id, email: this.item.email, visitors, premium: false });
            //console.log(checkoutUrl);
            window.location.assign(checkoutUrl);
          }
        },
        async changePlan() {
          this.confirmChange = false;
          this.loading = true;
          await this.$store.dispatch('companies/changePlan', { companyID: this.item.id, visitors: this.newPlan, premium: false });
          this.newPlan = null;
          this.$timer.start('reloadCompany')
        },
        async reloadCompany() {
          let p = await Promise.all([
            this.$store.dispatch('companies/get', {id: this.item.id }),
            this.$store.dispatch('companies/paymentInformation', {id: this.item.id})
          ])
          this.paymentInformation = p[1];
          this.loading = false;
        }
        
    },
    async created() {
      let p = await Promise.all([
        // payment information is queried separately due to access rights
        this.$store.dispatch('companies/paymentInformation', {id: this.$route.params.company}),
        this.$store.dispatch('companies/plans', {id: this.$route.params.company})
      ]) 
      this.paymentInformation = p[0];
      this.plans = p[1];
      console.debug('pricing plans', this.plans);
      this.planIndex = Math.max(this.plans.findIndex(p => this.isCurrent(p)), 0);
      this.loading = false;
      if(this.$route.query.cancel) {
        this.$store.dispatch('ui/notify', {error: true, text: this.$t('plan.errors.checkoutCancelled')});
      }
    },
    timers: {
      reloadCompany: { time: 5000, autostart: false, repeat: false }
    }
  }
</script>

<style lang="scss" scoped>
@include media("md-and-up") {
  .pricing-highlight {
    z-index: 1;
    transform: scale(1.1);
  }
}
</style>
